<script>
    import axios from 'axios';
    import LoadingIndicator from '#components/router/LoadingIndicator.svelte';
    import Router from '#components/router/Router.svelte';
    import { routes } from '#login/routes.js';
    import { theme } from '#login/stores/theme.js';
    import { loginErrors } from '#login/stores/errors.js';
    import { translationsStore } from '#stores/translations/translations.js';
    import { enableSSO, onlySSOLogin } from '#login/stores/settings.js';
    import { helpScoutRedirectInfoStore } from '#login/stores/redirect.js';

    const { themeOptions = {}, errors = {}, helpScoutRedirectInfo = {} } = $props();
    let completelyLoaded = $state(false);

    init();

    async function init() {
        $theme = themeOptions ?? {};
        $loginErrors = errors ?? {};
        $helpScoutRedirectInfoStore = helpScoutRedirectInfo;
        // eslint-disable-next-line no-undef
        $enableSSO = singleSignOnEnabled;
        // eslint-disable-next-line no-undef
        $onlySSOLogin = onlySSOEnabled;

        await setupTranslationsStore();

        completelyLoaded = true;
    }

    async function setupTranslationsStore() {
        $translationsStore = {
            ...(await axios.get('/api/v2/translations')).data.data,
            ...(await axios.get('/api/v2/translations?page=1')).data.data,
        };
    }
</script>

{#if completelyLoaded}
    <Router {routes} />
{:else}
    <LoadingIndicator />
{/if}
